import { Box, Typography } from '@material-ui/core'
import React from 'react'
import { OutlinedButton } from '../../irmlib/src/components/Controls'
import { useHistory } from 'react-router-dom'
import * as routePaths from '../../navigation/routePaths'
import { getUser } from '../../redux/global'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const ErrorPage = (props) => {
  const { t } = useTranslation()
  const roleOfUser = getUser()?.userRolesObj?.gdeRole
  const history = useHistory()
  const goToDashboard = () => {
    switch (roleOfUser) {
      case 'Admin': {
        history.push(`${routePaths.adminDashboard}`)
        break
      }
      case 'Supervisor': {
        history.push(`${routePaths.supervisorDashboard}`)
        break
      }
      case 'Data Entry': {
        history.push(`${routePaths.userDashboard}`)
        break
      }
      case 'Super User': {
        history.push(`${routePaths.adminDashboard}`)
        break
      }
      default: {
        history.push(`${routePaths.userDashboard}`)
      }
    }
  }

  return (
    <>
      {
        props.allowAccess
          ? <><Box component='div' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column' }}>
            <Typography variant='h3' style={{ padding: '1rem', fontSize: '25px', textAlign: 'center' }} >{t('demo.noAccess')}</Typography>
            <OutlinedButton onClick={goToDashboard}>demo.goToDashboard</OutlinedButton>
          </Box>
          </>
          : <Box component='div' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column' }}>
            <Typography variant='h3' style={{ padding: '1rem' }} >{t('demo.pageNotFound')}</Typography>
            <OutlinedButton onClick={goToDashboard}>demo.goToDashboard</OutlinedButton>
          </Box>
      }
    </>
  )
}

ErrorPage.propTypes = {
  allowAccess: PropTypes.bool,
}

export default ErrorPage